/* eslint-disable import/no-cycle */
import store from "store2";
import {
  createPreloadTrials,
  generateAssetObject,
  getDevice,
} from "@bdelab/roar-utils";
import assets from "../../assets.json";
import { Clowder, prepareClowderCorpus } from "@bdelab/jscat";

const bucketURI = "https://storage.googleapis.com/roar-survey";

export const mediaAssets = generateAssetObject(assets, bucketURI);
export const preloadTrials = createPreloadTrials(assets, bucketURI).default;
export const isTouchScreen = getDevice() === "mobile";

export let clowder;

export const initializeClowder = () => {
  // Define the `cats` configuration
  const catsConfig = {
    practice: {
      method: "EAP", // MLE
      itemSelect: store.session("itemSelect"),
      minTheta: -8,
      maxTheta: 8,
      randomSeed: "seed-cat",
    },
    total: {
      method: "EAP", // MLE
      itemSelect: store.session("itemSelect"),
      minTheta: -8,
      maxTheta: 8,
      randomSeed: "seed-cat",
    },
    core: {
      method: "EAP", // MLE
      itemSelect: store.session("itemSelect"),
      minTheta: -8,
      maxTheta: 8,
      randomSeed: "seed-cat",
    },
    new: {
      method: "EAP", // MLE
      itemSelect: store.session("itemSelect"),
      minTheta: -8,
      maxTheta: 8,
      randomSeed: "seed-cat",
    },
    spare: {
      method: "EAP", // MLE
      itemSelect: store.session("itemSelect"),
      minTheta: -8,
      maxTheta: 8,
      randomSeed: "seed-cat",
    },
  };

  // if (store.session.get('config').earlyStopping) {

  // USE EXAMPLE IN CASE OF EARLY STOPPING

  // let earlyStoppingCats = null;

  // earlyStoppingCats = new StopAfterNItems({
  //   requiredItems: {
  //     letterNameLower: store.session.get('config').nItems ?? 5,
  //     letterNameUpper: store.session.get('config').nItems ?? 5,
  //     letterPhoneme: store.session.get('config').nItems ?? 15,
  //   },
  //   logicalOperation: store.session.get('config').logicalOperation ?? 'only',
  // });

  // USE IN CASE OF SEPARATE CATS

  // const corpusLetterNameLower = encorpusLetterNameLower.map((row) => ({
  //   stimulus: row.target,
  //   zetas: [
  //     {
  //       cats: ['letterNameLower'],
  //       zeta: {
  //         a: row.a,
  //         b: row.b,
  //         c: row.c,
  //         d: row.d,
  //       },
  //     },
  //   ],
  //   ..._omit(row, ['a', 'b', 'c', 'd']),
  // }));

  const corpus = store.session.get("corpora");

  const combinedCorpus = [...corpus.practice, ...corpus.stimulus];

  const clowderCorpus = prepareClowderCorpus(
    combinedCorpus,
    ["total", "core", "new", "spare", "practice"],
    ".",
  );

  clowder = new Clowder({
    cats: catsConfig, // [spare, new, core, total] cats
    corpus: clowderCorpus,
    randomSeed: store.session.get("config").randomSeed ?? "random-seed",
    // earlyStopping: earlyStoppingCats,
  });

  store.session.set("clowder", clowder);
};

export const setNextStimulus = () => {
  const itemGroupCounter = store.session.get("itemGroupCounter");
  const coreRemaining = store.session.get("coreRemaining");
  const newRemaining = store.session.get("newRemaining");
  const spareRemaining = store.session.get("spareRemaining");
  const practiceRemaining = store.session.get("practiceRemaining");

  let catToSelect;

  if (practiceRemaining > 0) {
    catToSelect = "practice";
    store.session.set("practiceRemaining", practiceRemaining - 1);
  } else {
    // Your existing logic
    catToSelect =
      coreRemaining > 0
        ? itemGroupCounter % 4 === 0 && newRemaining > 0 && itemGroupCounter > 0
          ? "new"
          : "core"
        : newRemaining > 0
        ? itemGroupCounter % 4 === 0 &&
          spareRemaining > 0 &&
          itemGroupCounter > 0
          ? "spare"
          : "new"
        : spareRemaining > 0
        ? "spare"
        : undefined;

    if (catToSelect) {
      if (catToSelect === "core") {
        store.session.set("coreRemaining", coreRemaining - 1);
        store.session.set("itemGroupCounter", itemGroupCounter + 1);
      } else if (catToSelect === "new") {
        store.session.set("newRemaining", newRemaining - 1);
        store.session.set("itemGroupCounter", 0);
      } else if (catToSelect === "spare") {
        store.session.set("spareRemaining", spareRemaining - 1);
        store.session.set("itemGroupCounter", 0);
      }
      // Update remaining items and reset counters
      store.session.set("itemGroupCounter", itemGroupCounter + 1);
    }
  }

  store.session.set("catName", catToSelect);

  const previousItem = store.session.get("previousItem");
  const previousAnswer = store.session.get("previousAnswer");

  const nextStimulus = clowder.updateCatAndGetNextItem({
    catToSelect,
    catsToUpdate: catToSelect ? [catToSelect] : [],
    items: previousItem ?? undefined,
    answers: previousAnswer ?? undefined,
    randomlySelectUnvalidated: false,
  });

  if (nextStimulus === undefined) {
    store.session.remove("nextStimulus");
  } else {
    store.session.set("nextStimulus", nextStimulus);
  }
};

// USE THIS IN CASE OF MULTIPLE BLOCKS

// export const moveToNextBlock = () => {
//   const catIndex = (store.session.get('currentCatIndex') ?? -1) + 1;
//   store.session.set('subTaskName', catToSubTaskMap[catOrderMap[catIndex]]);
//   store.session.set('currentCatIndex', catIndex);
//   store.session.set('correctItems', []);
//   store.session.set('incorrectItems', []);
//   store.session.set('trialNumSubtask', 0); // counter for trials in subtask
// };
